/**
 * Response-only and timing keys for version 2.
 *
 * @public
 */
export const CMCD_RESPONSE_KEYS = [
	'cmsdd',
	'cmsds',
	'rc',
	'smrt',
	'ttfb',
	'ttfbb',
	'ttlb',
	'url',
] as const
